module.exports = __webpack_public_path__ + "img/wave_w516_h173_1x.4c459b12.png";